<script setup>
</script>

<template>
  <div
    class="tw-bg-caution-100 tw-border tw-border-caution tw-rounded-xl tw-py-4 tw-px-5 tw-flex tw-gap-4 tw-items-start tw-w-full"
  >
    <svg-vue
      class="tw-w-6 tw-h-6 tw-flex-shrink-0 tw-text-caution"
      icon="icons/warning-thin"
    />
    <div class="tw-flex tw-flex-col tw-gap-2">
      <slot name="title">
        <span class="tw-text-base tw-font-semibold tw-text-neutral-900">
          White-Label Email Not Configured
        </span>
      </slot>
      <slot />
    </div>
  </div>
</template>
